import { Link } from "@tanstack/react-router";
import { Mail, Phone, ShieldCheck } from "lucide-react";
import wordmarkRed from "../assets/logo-wordmark-red.webp";
import kMarkRed from "../assets/k-mark-red.webp";

const PRODUCT = [
  { to: "/experience", label: "Experience" },
  { to: "/solutions", label: "Solutions" },
  { to: "/intelligence", label: "Business Intelligence" },
  { to: "/trust", label: "Trust & Security" },
] as const;

const COMPANY = [
  { to: "/demo", label: "Book a demo" },
  { to: "/affiliate", label: "Affiliate programme" },
  { to: "/login", label: "Partner login" },
] as const;

export function SiteFooter() {
  return (
    <footer className="tk-defer relative bg-tk-char text-tk-cream">
      <div className="mx-auto grid max-w-content gap-14 px-gutter py-20 md:grid-cols-[1.4fr_1fr_1fr_1.1fr]">
        <div>
          <img src={wordmarkRed} alt="thatKorner" width={1600} height={542} decoding="async" className="h-9 w-auto" />
          <p className="mt-6 max-w-xs text-[14px] leading-[1.65] text-tk-mute">
            An AI-driven hospitality concierge for luxury restaurants, hotels, and
            cabins — engineered to disappear into the experience.
          </p>
          <p className="mt-6 text-[12.5px] leading-relaxed text-tk-mute-2">
            KARV VENTURES LLC<br />
            First Floor, Sharjah Media City,<br />
            Al Batayih, Sharjah, UAE.
          </p>
          <div className="mt-6 inline-flex items-center gap-2 rounded-full border border-tk-line bg-tk-ink/60 px-3 py-1.5 text-[10.5px] uppercase tracking-[0.22em] text-tk-cream/70">
            <ShieldCheck className="h-3.5 w-3.5 text-tk-red" />
            Provisional patented technology
          </div>
        </div>

        <FooterCol title="Product" items={PRODUCT} />
        <FooterCol title="Company" items={COMPANY} />

        <div>
          <p className="font-display text-[11px] font-light uppercase tracking-[0.32em] text-tk-red-2">
            Connect
          </p>
          <ul className="mt-6 space-y-3 text-[14px]">
            <li>
              <a
                href="mailto:contact@thatkorner.com"
                className="inline-flex items-center gap-2.5 text-tk-cream/85 transition-colors hover:text-tk-red"
              >
                <Mail className="h-4 w-4 text-tk-mute" />contact@thatkorner.com
              </a>
            </li>
            <li>
              <a
                href="tel:+971559767778"
                className="inline-flex items-center gap-2.5 text-tk-cream/85 transition-colors hover:text-tk-red"
              >
                <Phone className="h-4 w-4 text-tk-mute" />+971 55 976 7778
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="mx-auto h-px max-w-content bg-tk-line" />

      <div className="mx-auto flex max-w-content flex-col items-center justify-between gap-3 px-gutter py-6 text-[12px] text-tk-mute md:flex-row">
        <div className="flex items-center gap-3">
          <img src={kMarkRed} alt="" width={1600} height={1600} loading="lazy" decoding="async" className="h-4 w-4 opacity-80" />
          <span>© {new Date().getFullYear()} thatKorner — All rights reserved.</span>
        </div>
        <div className="flex items-center gap-5">
          <a href="#" className="hover:text-tk-cream">Privacy</a>
          <a href="#" className="hover:text-tk-cream">Terms</a>
          <a href="#" className="hover:text-tk-cream">Cookies</a>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({
  title,
  items,
}: {
  title: string;
  items: ReadonlyArray<{ to: "/experience" | "/solutions" | "/intelligence" | "/trust" | "/demo" | "/login" | "/affiliate"; label: string }>;
}) {
  return (
    <div>
      <p className="font-display text-[11px] font-light uppercase tracking-[0.32em] text-tk-red-2">
        {title}
      </p>
      <ul className="mt-6 space-y-3 text-[14px]">
        {items.map((it) => (
          <li key={it.to}>
            <Link
              to={it.to}
              className="text-tk-cream/85 transition-colors hover:text-tk-red"
            >
              {it.label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
